// Centralised images
export const galleryImages = [
  {
    src: "https://dobralakiernia.pl/images/home-018-370x222.jpg",
    title: { pl: "Brama przesuwna", en: "Sliding gate" },
    meta: { pl: "Lakierowanie proszkowe · 2023", en: "Powder coating · 2023" },
    span: "wide",
  },
  {
    src: "https://dobralakiernia.pl/images/home-016-370x222.jpg",
    title: { pl: "Zabytkowy motocykl", en: "Vintage motorcycle" },
    meta: { pl: "Lakierowanie proszkowe · 2023", en: "Powder coating · 2023" },
    span: "wide",
  },
  {
    src: "https://dobralakiernia.pl/images/home-08-370x222.jpg",
    title: { pl: "Felgi", en: "Wheels" },
    meta: { pl: "Lakierowanie · 2023", en: "Coating · 2023" },
    span: "wide",
  },
  {
    src: "https://dobralakiernia.pl/images/spawanie-13-560x564.jpg",
    title: { pl: "Elementy stołu", en: "Table components" },
    meta: { pl: "Lakier proszkowy · 2023", en: "Powder coating · 2023" },
    span: "square",
  },
  {
    src: "https://dobralakiernia.pl/images/spawanie-01-1676x731.jpg",
    title: { pl: "Stół metalowy", en: "Metal table" },
    meta: { pl: "Lakier proszkowy · 2022", en: "Powder coating · 2022" },
    span: "panorama",
  },
  {
    src: "https://dobralakiernia.pl/images/home-01-494x400.jpg",
    title: { pl: "Myjnia samoobsługowa", en: "Self-service car wash" },
    meta: { pl: "Konstrukcja stalowa · 2020", en: "Steel structure · 2020" },
    span: "square",
  },
  {
    src: "https://dobralakiernia.pl/images/home-02-494x400.jpg",
    title: { pl: "Myjnia Eterna", en: "Eterna car wash" },
    meta: { pl: "Konstrukcja · 2020", en: "Structure · 2020" },
    span: "square",
  },
  {
    src: "https://dobralakiernia.pl/images/home-03-494x400.jpg",
    title: { pl: "Reklama zewnętrzna", en: "Outdoor signage" },
    meta: { pl: "Bank Polski · 2020", en: "Bank Polski · 2020" },
    span: "square",
  },
  {
    src: "https://dobralakiernia.pl/images/home-04-494x400.jpg",
    title: { pl: "Myjnia Intermarché", en: "Intermarché car wash" },
    meta: { pl: "Konstrukcja · 2020", en: "Structure · 2020" },
    span: "square",
  },
];

export const heroBg =
  "https://static.prod-images.emergentagent.com/jobs/0a838e9f-ca2a-4391-b3a3-b1278f212760/images/c397fd391bae33fa8f4561fff4013fa81580d342936885fea23fbdc61204470f.png";

export const sectionImages = {
  // Real-world powder-coating: worker spraying powder on metal pipes/structural elements
  powderCoating:
    "https://images.pexels.com/photos/36215204/pexels-photo-36215204.jpeg?auto=compress&cs=tinysrgb&w=1600",
  // Industrial sandblasting: worker in full protective gear operating sandblasting equipment
  sandblasting:
    "https://images.pexels.com/photos/28628031/pexels-photo-28628031.jpeg?auto=compress&cs=tinysrgb&w=1600",
  furnace:
    "https://static.prod-images.emergentagent.com/jobs/0a838e9f-ca2a-4391-b3a3-b1278f212760/images/cdf44134b2d54df62aa2121059cd71801b3dd198ed2837c48f6002b98d1a6982.png",
};
